import { render } from "./mypath_test.vue?vue&type=template&id=7e58eacf"
import script from "./mypath_test.vue?vue&type=script&lang=js"
export * from "./mypath_test.vue?vue&type=script&lang=js"

import "./mypath_test.vue?vue&type=style&index=0&id=7e58eacf&lang=css"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__